import { render, staticRenderFns } from "./DeliverooOptionsForm.vue?vue&type=template&id=64667607"
import script from "./DeliverooOptionsForm.vue?vue&type=script&lang=ts"
export * from "./DeliverooOptionsForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports